const fr = {
  // Navigation
  nav_home: "Maison",
  nav_explore: "Explorer",
  nav_workspace: "Espace de travail",
  ws_videos: "vidéos",
  ws_untitled: "Vidéo sans titre",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "La vidéo a échoué",
  ws_failed_refunded: "Votre crédit a été restitué",
  ws_failed_dismiss: "Rejeter",
  ws_failed_retry: "Essayer à nouveau",
  ws_failed_retrying: "Départ…",
  ws_failed_banner_one: "Une vidéo n'a pas pu être générée",
  ws_failed_banner_many: "{n} vidéos ont échoué",
  ws_failed_banner_body: "Rien n'a été débité : le crédit est revenu sur votre compte. Réessayez ou choisissez un autre sujet.",
  ws_empty_title: "Rien ici encore.",
  ws_empty_body: "Chaque vidéo que vous réalisez apparaîtra ici, la plus récente en premier.",
  ws_generate: "Générer",
  ws_composer_placeholder: "Décrire une leçon\u2026",
  ws_placeholder_hw: "Nommez le devoir… (facultatif)",
  ws_placeholder_lecture: "Nommez la conférence… (facultatif)",
  ws_placeholder_self_study: "Que veux-tu étudier ?",
  nav_search: "Rechercher des vidéos...",
  nav_search_yours: "Recherchez vos vidéos...",
  nav_notifications: "Notifications",
  nav_mark_all_read: "Marquer tout comme lu",
  nav_no_notifications: "Aucune notification pour l'instant",
  nav_no_notifications_sub: "Nous vous avertirons lorsque vos vidéos seront prêtes",
  nav_upgrade: "Mise à niveau",
  nav_billing: "Facturation",
  nav_settings: "Paramètres",
  nav_contact: "Contactez-nous",
  nav_api: "API",
  nav_sign_out: "se déconnecter",
  nav_just_now: "Tout à l' heure",
  nav_minutes_ago: "il y a {n}il y a",
  nav_hours_ago: "il y a {n}h",
  nav_days_ago: "il y a {n}d",
  nav_used_this_month: "{used} sur {cap} utilisés ce mois-ci",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} sur {limit} utilisés cette semaine",
  nav_free_daily: "4 vidéos gratuites par semaine",
  // Settings
  settings_title: "Paramètres",
  settings_profile: "Profil",
  settings_change_avatar: "Changer d'avatar",
  settings_cancel: "Annuler",
  settings_choose_wizard: "Choisissez votre assistant",
  settings_display_name: "Nom d'affichage",
  settings_your_name: "Votre nom",
  settings_save: "Sauvegarder",
  settings_saving: "Économie...",
  settings_saved: "Enregistré",
  settings_save_failed: "Échec de l'enregistrement",
  settings_email: "E-mail",
  settings_notifications: "Notifications",
  settings_email_notif: "Notifications par courrier électronique",
  settings_email_notif_desc: "Recevez des mises à jour et des annonces par e-mail",
  settings_language: "Langue",
  settings_language_desc: "Choisissez la langue de l'application et de la narration vidéo",
  settings_data_title: "Vos données",
  settings_data_desc: "Téléchargez une copie des données personnelles associées à votre compte, y compris votre profil, vos vidéos, vos cours, vos sessions et vos messages d'assistance. Les journaux système internes et les données de traitement dérivées ne sont pas inclus.",
  settings_data_download: "Télécharger mes données",
  settings_data_exporting: "Préparation…",
  settings_danger: "Zone dangereuse",
  settings_delete_account: "Supprimer le compte",
  settings_delete_desc: "Supprimez définitivement votre compte et toutes les données associées. Cette action ne peut pas être annulée.",
  settings_delete_confirm: "Cela supprimera définitivement votre compte et toutes vos données. Tapez {keyword} pour confirmer.",
  settings_delete_placeholder: "Tapez \"SUPPRIMER\" pour confirmer",
  settings_permanently_delete: "Supprimer définitivement",
  settings_deleting: "Suppression...",
  explore_watch_now: "Regarder maintenant",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Pas d'aperçu",
  explore_no_videos: "Aucune vidéo disponible pour l'instant. Revenez bientôt !",
  explore_featured_courses: "Cours en vedette",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Retour à Explorer",
  course_not_found: "Ce cours n'est pas disponible.",
  // Home Page
  home_hero: "Apprenez n'importe quoi,",
  home_hero_accent: "visuellement",
  home_placeholder: "Que veux-tu apprendre ou résoudre ?",
  home_extracting: "Extraire les questions...",
  home_videos_generated: "{n, plural, one {# vidéo} other {# vidéos}} seront générées",
  home_credits: "{n, plural, one {# crédit} other {# crédits}}",
  home_remaining: "restant ce mois-ci",
  home_enter_prompt: "Veuillez entrer ce que vous voulez apprendre ou résoudre",
  home_popular: "Leçons populaires",
  home_from_community: "De la communauté",
  home_community_sub: "Découvrez ce que les étudiants créent",
  home_tips_label: "Du sorcier Mage",
  home_tips_title: "Trucs et astuces",
  home_tip1_title: "Soyez précis",
  home_tip1_desc: "Ne tapez pas un sujet entier. Choisissez une idée, un concept, une question.",
  home_tip1_example: "Comment fonctionne la réplication de l'ADN dans les cellules eucaryotes",
  home_tip2_title: "Dis à qui c'est",
  home_tip2_desc: "Une explication au collège est complètement différente d’un cours à l’université.",
  home_tip2_example: "Expliquer les dérivées à quelqu'un qui vient d'apprendre l'algèbre",
  home_tip3_title: "Dis à Magi ce que tu veux",
  home_tip3_desc: "Exemples, étapes par étapes, applications réelles : dites-le simplement et Magi suivra.",
  home_tip3_example: "Le cycle de l'eau avec des exemples concrets et un résumé",
  home_tip_try: "Essayez quelque chose comme",
  home_proven_social: "Suivez-nous sur Instagram",
  home_ig_desc_1: "Sur",
  home_ig_followers: "55 000 abonnés",
  home_ig_desc_2: "regardez nos vidéos de mathématiques et de sciences sur Instagram tous les jours. Ces moulinets sont fabriqués avec le même moteur que vous utilisez ici.",
  home_view_profile: "Voir le profil",
  home_subscribe_now: "Abonnez-vous maintenant",
  home_sub_monthly: "Mensuel",
  home_sub_yearly: "Annuel",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Économisez {pct} %",
  home_sub_per_month: "/ mois",
  home_sub_billed_monthly: "facturé {amount} $ chaque mois",
  home_sub_processing: "Traitement...",
  home_sub_no_commitment: "Aucun engagement. Annulez à tout moment.",
  home_sub_secured: "Sécurisé par Stripe",
  home_sub_headline: "Débloquez davantage avec {plan}",
  home_sub_due_now: "À rendre maintenant",
  home_sub_trial_label: "{days} jour d'accès complet",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Vous serez facturé ${amount} $ aujourd'hui pour {n} vidéos ce mois-ci. Le {date}, il se renouvelle à ${amount} $/mois, sauf si vous l'annulez au préalable : annulez à tout moment depuis la facturation.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Vous serez facturé ${trial} $ aujourd'hui pour {days} jours d'accès complet, limité à {n} vidéos. L'essai ne se poursuit pas à ${trial} : le {date}, il devient automatiquement {planName} à ${plan} par mois ({full} vidéos), et ${plan} est facturé chaque mois par la suite jusqu'à ce que vous l'annuliez. Annulez à tout moment depuis la facturation.",
  home_sub_card: "Carte de crédit ou de débit",
  home_sub_billed_once_yearly: "facturé {amount} $ une fois par an",
  home_sub_billed_trial: "facturé ${amount} $ pendant {days} jours, puis renouvelé à ${renews} $ chaque mois",
  home_sub_switch_plan: "Vous recherchez plutôt {plan} ?",
  home_sub_replaces_plan: "Remplace votre forfait {plan}. Votre date de facturation reste la même : la hausse facture la différence maintenant, la baisse commence lors de votre prochain renouvellement.",
  home_sub_change_now: "Vous êtes maintenant sur {plan} — {amount} facturés pour la différence.",
  home_sub_change_later: "Vous passerez à {plan} le {date}. Rien n'est facturé aujourd'hui.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} vidéos par mois",
  // Pricing Page
  pricing_title: "Améliorez votre forfait",
  pricing_monthly: "Mensuel",
  pricing_yearly: "Annuel",
  pricing_save: "Économisez 17 %",
  pricing_best_value: "Meilleur rapport qualité-prix",
  pricing_your_plan: "Votre forfait actuel",
  pricing_get_started: "Commencer",
  pricing_processing: "Traitement...",
  pricing_per_month: "/mois",
  pricing_billed_yearly: "Facturé ${amount} $/an",
  pricing_videos_month: "{n, plural, one {# vidéo} other {# vidéos}}/mois",
  pricing_manage_cancel: "Gérer ou annuler",
  pricing_manage_unavailable: "Nous n'avons pas trouvé d'abonnement à gérer. Contactez-nous et nous réglerons cela.",
  pricing_opening: "Ouverture...",
  billing_autorenew_monthly: "Se renouvelle automatiquement à ${amount} $/mois jusqu'à votre annulation.",
  billing_autorenew_yearly: "Se renouvelle automatiquement à ${amount} $/an jusqu'à votre annulation.",
  billing_autorenews_on: "Renouvellement automatique {date} · annuler à tout moment",
  pricing_secured: "Sécurisé par Stripe",
  pricing_login_required: "Veuillez vous connecter pour vous abonner",
  pricing_auth_error: "Erreur d'authentification de l'utilisateur. Veuillez essayer de vous déconnecter et de vous reconnecter.",
  pricing_feature_pdf: "Extraction de PDF et d'images",
  pricing_feature_quality: "Modèle de qualité supérieure",
  pricing_feature_speed: "Temps de génération plus rapide",
  pricing_feature_study: "Séances d'études",
  pricing_free_hint: "Actuellement sur le plan gratuit",
  // Billing Page
  billing_title: "Facturation",
  billing_current_plan: "Forfait actuel",
  billing_payment_failed_title: "Votre forfait est suspendu",
  billing_payment_failed_body: "Nous n'avons pas pu collecter {amount}. Votre forfait est donc suspendu. Mettez à jour votre carte pour la redémarrer. Nous réessayerons également.",
  billing_payment_failed_cta: "Régler le paiement",
  billing_change_plan: "Changer de forfait",
  billing_invoices: "Factures",
  billing_loading: "Chargement des factures...",
  billing_no_invoices: "Pas encore de factures",
  billing_date: "Date",
  billing_amount: "Montant",
  billing_status: "Statut",
  billing_invoice: "Facture",
  billing_view: "Voir",
  // Contact Page
  contact_title: "Contactez-nous",
  contact_placeholder: "Comment pouvons-nous vous aider ?",
  contact_sent_desc: "Nous vous répondrons dans les plus brefs délais.",
  contact_signin: "Veuillez vous connecter pour contacter l'assistance.",
  // Generation Queue
  queue_title: "File d'attente",
  queue_active: "{n} actif",
  queue_generating: "{n} générer",
  queue_ready: "Prêt à regarder",
  queue_in_queue: "En attente dans la file...",
  queue_almost_ready: "Presque prêt...",
  queue_seconds_left: "il reste {n}",
  queue_minutes_left: "Il reste {m}m {s}",
  queue_watch_now: "Regardez maintenant",
  queue_waiting: "En attente dans la file d'attente...",
  queue_empty: "Aucune vidéo en file d'attente",
  queue_empty_sub: "Générez une vidéo pour la voir ici",
  queue_clear: "Tout effacer",
  queue_total: "{n} total",
  queue_first_time: "Votre vidéo est en cours de génération",
  queue_first_time_sub: "Généralement environ 2 minutes. Vous entendrez un carillon quand il sera prêt.",
  // Session Expired
  session_expired: "Session expirée",
  session_expired_desc: "Votre session a expiré pour des raisons de sécurité. Veuillez vous reconnecter pour continuer.",
  // Cookie Banner
  cookie_text: "Nous utilisons des cookies pour analyser le trafic du site et améliorer votre expérience. Seuls les cookies essentiels sont définis par défaut.",
  cookie_learn_more: "Apprendre encore plus",
  cookie_accept: "Acceptez tout",
  cookie_reject: "Rejeter les produits non essentiels",
  // Create Project Modal
  create_new_project: "Nouveau projet",
  create_extracting: "Extraction...",
  create_select_problems: "Sélectionnez les problèmes",
  create_select_topics: "Sélectionnez des sujets",
  create_new_video: "Nouvelle vidéo",
  create_new_hw: "Nouveau projet de devoirs",
  create_new_lecture: "Nouveau projet de conférence",
  create_new_self_study: "Nouveau projet",
  create_video: "Vidéo",
  create_homework: "Devoirs",
  create_lecture: "Conférence",
  create_self_study: "Projet",
  create_video_sub: "Générer une vidéo",
  create_hw_sub: "Télécharger les devoirs",
  create_lecture_sub: "Télécharger des diapositives",
  create_self_study_sub: "Choisissez vos sujets",
  create_video_prompt: "Que doit expliquer la vidéo ?",
  create_project_title: "Titre du projet",
  create_video_hint: "Celui-ci sera utilisé à la fois comme titre et comme invite pour votre vidéo.",
  create_drop_hw: "Déposez vos devoirs ici",
  create_drop_lecture: "Déposez vos diapositives de cours ici",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Drop pour démarrer un projet",
  create_reading_hw: "Lire ses devoirs",
  create_reading_lecture: "Lire votre conférence",
  create_finding_problems: "Trouver et extraire des problèmes...",
  create_finding_topics: "Extraction de sujets...",
  create_add_video: "Ajouter une autre vidéo",
  create_add_more_files: "Ajouter plus de fichiers",
  create_starting: "Génération de départ...",
  create_generate_video: "Générer une vidéo \u00B7 1 crédit",
  create_generate_n: "Générer {n, plural, one {# vidéo} other {# vidéos}} \u00B7 {n, plural, one {# crédit} other {# crédits}}",
  create_create_project: "Créer un projet \u00B7 {n, plural, one {# crédit} other {# crédits}}",
  create_no_problems: "Je n'ai trouvé aucun problème. Essayez une photo plus claire ou une page différente.",
  create_no_topics: "Je n'ai trouvé aucun sujet. Essayez une photo plus claire ou un fichier différent.",
  create_error: "Quelque chose s'est mal passé. Veuillez réessayer.",
  create_extract_daily_limit: "C'est tous les documents pour aujourd'hui. Plus demain.",
  create_video_topic_placeholder: "Sujet de la vidéo {n}, par ex. \"Valeurs propres et vecteurs propres\"",
  video_share: "Partager",
  // and made the two indistinguishable.
  video_followup_placeholder: "Générer une vidéo de suivi...",
  video_chip_simpler: "Expliquez plus simplement",
  video_chip_harder: "Exemple plus difficile",
  video_chip_real_world: "Utilisation dans le monde réel",
  // spends a credit generating a new one.
  video_ask_title: "Posez des questions sur cette vidéo",
  video_ask_cta: "Discutez à ce sujet",
  video_ask_placeholder: "Posez une question...",
  video_ask_thinking: "Pensée...",
  video_ask_close: "Fermer",
  video_ask_chip_explain: "Expliquez cette partie",
  video_ask_chip_example: "Donnez un exemple",
  video_ask_chip_why: "Pourquoi ça marche ?",
  video_ask_limit_reached: "Vous avez atteint la limite de questions d'aujourd'hui. Il se réinitialise demain.",
  video_up_next: "Suivant",
  video_no_suggested: "Aucune vidéo suggérée pour l'instant",
  video_untitled: "Vidéo sans titre",
  video_created_recently: "Créé récemment",
  video_just_now: "Tout à l' heure",
  video_minutes_ago: "il y a {n, plural, one {# minute} other {# minutes}}",
  video_hours_ago: "il y a {n, plural, one {# heure} other {# heures}}",
  video_days_ago: "il y a {n, plural, one {# jour} other {# jours}}",
  video_weeks_ago: "il y a {n, plural, one {# semaine} other {# semaines}}",
  video_months_ago: "il y a {n, plural, one {# mois} other {# mois}}",
  video_years_ago: "il y a {n, plural, one {# an} other {# ans}}",
  video_unknown_date: "Date inconnue",
  video_download_error: "Quelque chose s'est mal passé. Veuillez réessayer.",
  // Search Results
  search_no_results: "Aucun résultat trouvé",
  search_no_results_for: "Aucun résultat trouvé pour \"{query}\"",
  search_all_videos: "Rechercher toutes les vidéos",
  search_enter_term: "Entrez un terme de recherche pour trouver des vidéos",
  search_retry: "Réessayer la recherche",
  auth_continue_google: "Continuer avec Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Démarrez mon accès immédiatement. Je comprends que cela signifie que je renonce à mon droit de rétractation de {days} jours et d'obtenir un remboursement.",
  home_sub_waiver_required: "Veuillez confirmer ceci pour continuer.",
  home_sub_agree_prefix: "En continuant, vous acceptez notre",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Vous devez avoir {age} ou plus pour utiliser Magi.",
  auth_agree_prefix: "En vous connectant, vous acceptez notre",
  auth_terms: "Conditions d'utilisation",
  auth_and: "et",
  auth_privacy: "politique de confidentialité",
  auth_email_optin: "Envoyez-moi des conseils et des mises à jour",
  // Auth modal (Google + email/password)
  auth_signin_title: "Connectez-vous à Magi",
  auth_signin_desc: "Reprenez là où vous vous êtes arrêté.",
  auth_signup_title: "Créez votre compte",
  auth_signup_desc: "Démarrage gratuit, aucune carte nécessaire.",
  auth_or: "ou",
  auth_continue_email: "Continuer avec l'e-mail",
  auth_signing_in: "Connexion…",
  auth_working: "Juste une seconde…",
  auth_email_placeholder: "Adresse email",
  auth_password_placeholder: "Mot de passe",
  auth_signin_submit: "Se connecter",
  auth_signup_submit: "Créer un compte",
  auth_no_account: "Nouveau ici ?",
  auth_signup_link: "Créer un compte",
  auth_have_account: "Vous avez déjà un compte ?",
  auth_signin_link: "Se connecter",
  auth_forgot_password: "Vous avez oublié votre mot de passe ?",
  auth_reset_title: "Réinitialisez votre mot de passe",
  auth_reset_desc: "Nous vous enverrons par e-mail un lien pour en définir un nouveau.",
  auth_reset_submit: "Envoyer le lien de réinitialisation",
  auth_reset_sent: "Vérifiez votre courrier électronique pour le lien de réinitialisation.",
  auth_back_to_signin: "Retour pour vous connecter",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Confirmez votre email pour continuer",
  verify_wall_desc: "Nous avons envoyé un lien de confirmation à {email}. Cliquez dessus, puis revenez ici.",
  verify_wall_check: "je l'ai confirmé",
  verify_wall_checking: "Vérification...",
  verify_wall_still_unverified: "Pas encore confirmé. Cliquez sur le lien dans l'e-mail, puis réessayez.",
  verify_wall_resend: "Renvoyez le lien",
  verify_wall_resent: "Envoyé. Vérifiez votre boîte de réception et votre dossier spam.",
  verify_wall_wrong_account: "Mauvais compte ? se déconnecter",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Confirmation de votre email",
  verify_action_working_desc: "Un instant.",
  verify_action_done_title: "Vous êtes prêt",
  verify_action_done_desc: "Votre email est confirmé. Bienvenue chez Magi.",
  verify_action_done_cta: "Commencez à apprendre",
  verify_action_failed_title: "Ce lien n'a pas fonctionné",
  verify_action_failed_desc: "Il a peut-être déjà été utilisé ou il a expiré. Revenez et envoyez-vous-en un nouveau.",
  verify_action_failed_cta: "Retour à Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Connectez-vous pour regarder",
  auth_watch_desc: "Créez un compte gratuit pour lire cette vidéo.",
  auth_watch_ready_title: "Votre vidéo est prête",
  auth_watch_ready_desc: "Connectez-vous pour le regarder : il sera enregistré sur votre compte.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Connectez-vous pour télécharger",
  auth_download_desc: "Créez un compte gratuit pour enregistrer cette vidéo.",
  auth_ask_title: "Connectez-vous pour demander",
  auth_ask_desc: "Créez un compte gratuit pour poser des questions sur cette vidéo.",
  auth_browse_title: "Connectez-vous pour parcourir",
  auth_browse_desc: "Créez un compte gratuit pour explorer chaque leçon.",
  auth_workspace_title: "Connectez-vous pour voir votre travail",
  auth_workspace_desc: "Vos cours et projets vivent dans votre compte.",
  auth_generate_title: "Connectez-vous pour continuer à créer",
  auth_generate_desc: "Les comptes gratuits reçoivent une vidéo chaque jour.",
  video_restricted: "Cette vidéo n'est pas encore disponible.",
  // Share sheet
  share_title: "Partagez cette vidéo",
  share_desc_mobile: "Publiez-le dans votre story, envoyez-le à un ami ou copiez le lien.",
  share_desc_desktop: "Copiez le lien ou téléchargez la vidéo à publier depuis votre téléphone.",
  share_to_apps: "Partager sur Instagram et plus",
  share_copy_link: "Copier le lien",
  share_copied: "Lien copié",
  share_download: "Télécharger la vidéo",
  share_preparing: "On le prépare…",
  share_watermark_note: "Les vidéos partagées incluent magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "Bienvenue chez Magi",
  welcome_subtitle: "Vous disposez de 4 vidéos gratuites pour commencer.",
  welcome_optin_reward: "+1 vidéo gratuite",
  welcome_continue: "Continuer",
  age_gate_continue: "Continuer",
  age_gate_saving: "Économie...",
  // Landing Page
  landing_hero: "Tapez un sujet.",
  landing_hero2: "Obtenez une leçon vidéo.",
  landing_subtitle: "Magi transforme n'importe quel sujet en une vidéo magnifiquement animée et racontée en quelques minutes. Aucun tournage, aucun montage, aucune expertise nécessaire.",
  landing_signup_google: "Inscrivez-vous avec Google",
  landing_signing_in: "Connexion...",
  landing_chat_bubble: "Comment le GPS utilise-t-il la relativité ?",
  landing_stats_title: "Approuvé par les apprenants du monde entier",
  landing_stat_videos: "3 000+",
  landing_stat_videos_desc: "Vidéos générées",
  landing_stat_languages_desc: "Langues",
  landing_stat_speed: "~1 min",
  landing_stat_speed_desc: "Temps de génération",
  landing_feature_lecture_title: "Déposez vos notes de cours, obtenez des vidéos",
  landing_feature_lecture_desc: "Téléchargez vos diapositives ou notes. Magi extrait chaque sujet et génère une explication vidéo pour chacun.",
  landing_feature_hw_title: "Coincé avec ses devoirs ? Téléchargez-le.",
  landing_feature_hw_desc: "Déposez un ensemble de problèmes et Magi extrait chaque problème, puis vous guide à travers la solution dans une vidéo étape par étape.",
  landing_feature_chat_title: "Posez des questions pendant que vous regardez",
  landing_feature_chat_desc: "Chaque vidéo est accompagnée d'un tuteur IA avec lequel vous pouvez discuter. Posez des questions de suivi, obtenez des explications plus approfondies ou demandez une nouvelle vidéo sur une partie spécifique que vous souhaitez mieux comprendre.",
  landing_feature_lang_title: "Apprenez dans votre langue",
  landing_feature_lang_desc: "Magi génère des vidéos en anglais, espagnol, hindi, chinois, japonais et plus encore. Tapez votre sujet dans n'importe quelle langue et obtenez une leçon entièrement commentée dans cette langue.",
  landing_cta_title: "Commencez à apprendre en quelques secondes",
  landing_cta_google: "Continuer avec Google",
  // Onboarding Bubbles
  onboarding_step1: "Ceci n'est pas un chatbot \u2014 tapez un sujet et je générerai une leçon vidéo complète pour vous !",
  onboarding_step2: "Ou déposez un PDF ou une photo ; je transformerai chaque problème en une solution vidéo étape par étape",
  onboarding_step3: "Appuyez sur Go et votre vidéo rejoint la file d'attente. Vous pouvez continuer à naviguer pendant le rendu !",
  onboarding_generating: "C'est votre leçon qui est tirée dans quelques minutes. Continuez à naviguer si vous le souhaitez ; il atterrira ici quand il sera prêt.",
  onboarding_skip: "Sauter",
  onboarding_next: "Suivant",
  onboarding_done: "J'ai compris!",
  // Generating Cards Row
  generating_label: "Générateur",
  // Lecture Session (Self Study)
  lecture_loading: "Chargement...",
  lecture_fallback_title: "Conférence",
  lecture_building: "Vidéo de construction...",
  lecture_building_time: "Cela prend généralement 2 à 4 minutes",
  lecture_failed: "La génération vidéo a échoué",
  lecture_no_video: "Pas encore de vidéo",
  lecture_followup: "Suivi",
  lecture_now_playing: "Je joue en ce moment",
  lecture_tab_videos: "Vidéos",
  lecture_tab_chat: "Chat",
  lecture_chat_empty: "Demandez n'importe quoi sur ce sujet",
  lecture_chat_chip1: "Expliquez simplement",
  lecture_chat_chip2: "Donnez un exemple",
  lecture_chat_chip3: "Pourquoi est-ce utile ?",
  lecture_chat_placeholder: "Posez des questions sur ce sujet...",
  lecture_followup_placeholder: "Ajouter une vidéo de suivi...",
  lecture_chat_error: "Désolé, je n'ai pas pu traiter cela. Essayer à nouveau.",
  lecture_chat_generic_error: "Quelque chose s'est mal passé. Essayer à nouveau.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Devoirs PDF",
  home_sc_hw_desc: "Téléchargez un ensemble de problèmes, obtenez une vidéo travaillée pour chaque question",
  home_sc_lecture_title: "Cours PDF",
  home_sc_lecture_desc: "Transformez des diapositives ou des notes en une série de leçons",
  home_sc_course_title: "Créer un cours",
  home_sc_course_desc: "Planifier une séquence de cours sur un sujet",
  // Misc
  generic_error: "Quelque chose s'est mal passé. Veuillez réessayer.",
  loading: "Chargement...",
};

export default fr;
